import { render, staticRenderFns } from "./MyNotification.vue?vue&type=template&id=1b32443e&"
import script from "./MyNotification.vue?vue&type=script&lang=js&"
export * from "./MyNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports